export type ReschedulingReason = 'person_cancelled' | 'customer_cancelled' | 'other';

export const RESCHEDULING_REASONS: ReschedulingReason[] = [
  'person_cancelled',
  'customer_cancelled',
  'other',
];

export type InspectorFilterGroupId = 'preferred' | 'internal' | 'external';

export interface ShuffleInspector {
  id: number;
  name: string;
}

export interface ShuffleInspectorGroup {
  id: InspectorFilterGroupId;
  inspectors: ShuffleInspector[];
  totalCount: number;
}

export const INSPECTOR_FILTER_GROUP_IDS: InspectorFilterGroupId[] = [
  'preferred',
  'internal',
  'external',
];
